import { obterParametrosDaURL } from "../../../../functions";
import { api } from "../../api";
import { ApiException } from "../../api-exception";

export interface IValoresDoLoteDeContasAPagar {
  valorDoc: number;
  valorRestante: number;
  desconto?: number;
  jurosPago?: number;
  multa?: number;
  taxaCartorio?: number;
}

export const ObterValoresDoLoteDeContasAPagar = async (idLote: string) => {
  const { token } = obterParametrosDaURL();

  try {
    const { data } = await api.get<IValoresDoLoteDeContasAPagar>(
      `/total-lote-documentos`,
      {
        params: {
          idLote
        },
        headers: {
          token,
        },
      }
    );

    return data;
  } catch (erro) {
    throw new ApiException(
      erro,
      "Não conseguimos obter o valor total do lote de contas a pagar"
    );
  }
};